import React from 'react';
import { Heading } from '@grubhubprod/gh-cookbook-react';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';

export function InsightsDashboardName(): JSX.Element {
  const { displayName } = useBusinessInsightsContext();

  return <Heading variant="h2">{displayName}</Heading>;
}
